import { Layout, Menu } from 'antd';
import { useLocation, useNavigate } from 'react-router-dom';
import { layoutDimensions } from '@theme/tokens';

const { Header: AntHeader } = Layout;

export const Header = () => {
  const navigate = useNavigate();
  const location = useLocation();

  // Use the router location so selected menu only changes on explicit navigation (clicks / direct URL)
  const menuItems = [
    { key: '/', label: 'About' },
    { key: '/experience', label: 'Experience' },
    // { key: '/skills', label: 'Skills' },
    // { key: '/projects', label: 'Projects' },
    { key: '/contact', label: 'Contact' },
  ];

  return (
    <AntHeader className="header">
      <div className="logo">LM</div>
      <Menu
        theme="dark"
        mode="horizontal"
        selectedKeys={[location.pathname]}
        items={menuItems}
        onClick={({ key }) => {
          // Ensure navigation triggered by a header click is distinguishable from
          // scroll-driven navigation. We set state.viaClick so SinglePage will
          // perform the programmatic scroll. Additionally, schedule a fallback
          // scroll from the header itself in case the page transition event is
          // missed (ensures reliable UX).
          const path = String(key);
          navigate(path, { state: { viaClick: true } });

          // derive element id from path
          const id = path === '/' ? 'about' : path.replace(/^\//, '');
          const doScroll = () => {
            const el = document.getElementById(id);
            if (el) {
              const offsetTop = el.offsetTop - layoutDimensions.headerHeight;
              window.scrollTo({ top: offsetTop, behavior: 'auto' });
            }
          };

          // No page transitions anymore — scroll immediately after navigation.
          // SinglePage will also perform scroll-on-route-change; calling here
          // ensures immediate feedback if needed.
          setTimeout(doScroll, 0);
        }}
      />
    </AntHeader>
  );
};

export default Header;